export default "__VITE_ASSET__BiyH15li__"